import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { CompanyFieldComponent } from './company-field.component';


@NgModule({
  imports: [
    CommonModule,
    RouterModule,
  ],
  declarations: [
    CompanyFieldComponent,
  ],
  exports: [
    CompanyFieldComponent,
  ],
})
export class CompaniesExportModule {}
